// extracted by mini-css-extract-plugin
module.exports = {"backgroundGradient":"linear-gradient(180deg, #000 0%, rgba(14,12,12,0.1) .01%, rgba(0,0,0,0.5) 100%)"};